export default "__VITE_ASSET__DkMegizE__"